import { gql, graphQueryBang } from "shared/lib/graphql"

const BrandMetricsQuery = gql`
  query(
    $service: String!
    $metric_start_date: DataServiceDate!
    $metric_end_date: DataServiceDate!
    $works_with_channel_name: String
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $metric_start_date
      metric_end_date: $metric_end_date
      works_with_channel_module_name: $works_with_channel_name
    ) {
      metrics {
        metric_date
        applet_views_daily
        service_page_views_daily
      }
    }
  }
`

export default function brandMetricsFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  { dailyMetricStartDate, currentMetricDate }
) {
  return graphQueryBang(BrandMetricsQuery, {
    service: serviceModuleName,
    metric_start_date: dailyMetricStartDate,
    metric_end_date: currentMetricDate,
    category_name: categoryName,
    works_with_channel_name: worksWithChannelName,
  }).then(data => data.service_metrics.metrics)
}
